import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionLoveIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps({ ...props, viewBox: "0 0 28 28" })}>
    <rect fill="#F13359" height="28" rx="14" width="28" />
    <path
      d="M21.5618 8.34924C21.0477 7.86628 20.4254 7.49666 19.74 7.26719C19.0547 7.03772 18.3235 6.95485 17.5994 7.02325C16.8753 7.09164 16.1766 7.31029 15.5538 7.66332C14.931 8.01635 14.3999 8.49492 13.9989 9.06432C13.6174 8.53007 13.121 8.07657 12.5415 7.73297C11.9619 7.38936 11.3121 7.16326 10.6339 7.0692C9.95556 6.97513 9.26378 7.01518 8.60298 7.18678C7.94219 7.35838 7.327 7.65772 6.79696 8.06557C6.26691 8.47342 5.83375 8.98075 5.52532 9.55494C5.21688 10.1291 5.04 10.7575 5.00603 11.3996C4.97207 12.0417 5.08178 12.6834 5.3281 13.2834C5.57443 13.8834 5.95193 14.4284 6.43633 14.8834C6.43633 14.8834 12.8727 22 13.9989 22C15.125 22 21.5618 14.8834 21.5618 14.8834C22.4829 14.0155 23 12.8408 23 11.6164C23 10.3919 22.4829 9.21719 21.5618 8.34924Z"
      fill="white"
    />
  </svg>
);
